import React from 'react';
import './LegalInfo.css';
import Divider from '../VerticalsWePower/Divider';

const features = [
  'Semantic search',
  'Predictive insights',
  'Judicial analytics',
  'Multi-jurisdiction support',
];

const clientMatterFeatures = [
  'Smart intake',
  'Time billing',
  'Case lifecycle tracking',
  'Multi-party collaboration',
];

// Accepts an optional imageSrc prop for the blue box
const LegalInfo = ({ imageSrc }) => (
  <div className="legal-info-container">
    <div className="legal-info-header">
      <div className="legal-info-subtitle">WHAT CAN YOU ACCOMPLISH</div>
      <h2 className="legal-info-title">Powerful features. Smarter lawyering.</h2>
    </div>
    <div className="legal-info-main">
      <div className="legal-info-left">
        <h3>Legal Research Copilot</h3>
        <ul className="legal-info-feature-list">
          {features.map((feature, idx) => (
            <li key={idx}><img src="/images/checkicon.svg" alt="check" /> {feature}</li>
          ))}
        </ul>
        <div className="legal-info-see-how">
          <img src="/images/videoplay.svg" alt="Play video" className="see-how-icon" />
          See how it works
        </div>
      </div>
      <div className="legal-info-right">
        <div className="legal-info-video">
          {imageSrc ? (
            <img src={imageSrc} alt="Legal info visual" className="legal-info-image" />
          ) : null}
        </div>
      </div>
    </div>
    <div className="legal-info-horizontal-divider"></div>
    {/* <Divider/> */}
    {/* Client & Matter Management Grid Section */}
    <div className="client-matter-grid-section">
      <div className="client-matter-grid">
        <div className="client-matter-column">
          <h3>Client & Matter Management</h3>
          <div className="client-matter-features-row">
            <div><img src="/images/checkicon.svg" alt="check" /> Smart intake</div>
            <div><img src="/images/checkicon.svg" alt="check" /> Time billing</div>
          </div>
          <div className="client-matter-features-row">
            <div><img src="/images/checkicon.svg" alt="check" /> Case lifecycle tracking</div>
            <div><img src="/images/checkicon.svg" alt="check" /> Multi-party collaboration</div>
          </div>
          <div className="legal-info-see-how">
            <img src="/images/videoplay.svg" alt="Play video" className="see-how-icon" />
            See how it works
          </div>
          <div className="client-matter-video-box" />
        </div>
        <div className="client-matter-divider"></div>
        <div className="client-matter-column clc2">
          <h3>Client & Matter Management</h3>
          <div className="client-matter-features-row">
            <div><img src="/images/checkicon.svg" alt="check" /> Smart intake</div>
            <div><img src="/images/checkicon.svg" alt="check" /> Time billing</div>
          </div>
          <div className="client-matter-features-row">
            <div><img src="/images/checkicon.svg" alt="check" /> Case lifecycle tracking</div>
            <div><img src="/images/checkicon.svg" alt="check" /> Multi-party collaboration</div>
          </div>
          <div className="legal-info-see-how">
            <img src="/images/videoplay.svg" alt="Play video" className="see-how-icon" />
            See how it works
          </div>
          <div className="client-matter-video-box" />
        </div>
      </div>
    </div>
    {/* Legal Research Copilot Section (Bottom, heading and see-how in one row) */}
    <div className="copilot-horizontal-section">
      <div className="copilot-horizontal-title-row">
        <div className="copilot-horizontal-title">Legal Research Copilot</div>
        <div className="copilot-horizontal-see-how">
          <img src="/images/videoplay.svg" alt="Play video" className="see-how-icon" />
          See how it works
        </div>
      </div>
      <div className="copilot-horizontal-row copilot-horizontal-row-center">
        <div className="copilot-horizontal-features">
          {features.map((feature, idx) => (
            <div className="copilot-horizontal-feature" key={idx}>
              <img src="/images/checkicon.svg" alt="check" /> {feature}
            </div>
          ))}
        </div>
      </div>
      <div className="copilot-horizontal-video-box" />
    </div>
  </div>
);

export default LegalInfo; 